/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Api_Keys_Revoke_ConfirmInputs */

const vi_api_keys_revoke_confirm = /** @type {(inputs: Api_Keys_Revoke_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Thu hồi khóa "${i?.name}"? Dịch vụ đang dùng khóa này sẽ mất quyền truy cập ngay.`)
};

/**

* @param {Api_Keys_Revoke_ConfirmInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const api_keys_revoke_confirm = /** @type {((inputs: Api_Keys_Revoke_ConfirmInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Keys_Revoke_ConfirmInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_api_keys_revoke_confirm(inputs)
});